import memoizeOne from "memoize-one";
const gcd = (num, dom) => {
  let fract1 = null;
  let fract2 = null;
  if (num < dom) {
    fract1 = dom;
    fract2 = num;
  } else if (num > dom) {
    fract1 = num;
    fract2 = dom;
  } else if (num === dom) {
    return num;
  }
  while (fract2 !== 0) {
    const temp = fract2;
    fract2 = fract1 % fract2;
    fract1 = temp;
  }
  return fract1;
};
const reduce = (num, dom) => {
  const n = [];
  const f = gcd(num, dom);
  n[0] = num / f;
  n[1] = dom / f;
  return n;
};
const calculateFractional = (decimal) => {
  let num = (Number(decimal) - 1) * 1e4;
  let dom = 1e4;
  num = Math.round(num);
  const reduced = reduce(num, dom);
  const [newNum, newDom] = reduced;
  num = newNum;
  dom = newDom;
  return `${num}/${dom}`;
};
const usFromDecimal = memoizeOne((decimal) => {
  const dec = decimal !== 0 ? decimal - 1 : 0;
  const converted = dec !== 0 && dec < 1 ? `-${Math.ceil(Math.abs(100 / dec))}` : `+${Math.floor(Math.abs(dec * 100))}`;
  return dec !== 0 ? converted : 0;
});
const fractionalFromDecimal = memoizeOne((decimal) => {
  const dec = decimal === 0 ? 0 : decimal.toFixed(2);
  return dec !== 0 ? calculateFractional(dec) : 0;
});
const malaysianFromDecimal = memoizeOne((decimal) => {
  const converted = decimal !== 0 && decimal < 2 ? `+${Math.abs(decimal - 1).toFixed(3)}` : `-${Math.abs(1 / (decimal - 1)).toFixed(3)}`;
  return decimal !== 0 ? converted : 0;
});
const indonesianFromDecimal = memoizeOne((decimal) => {
  const converted = decimal !== 0 && decimal < 2 ? `-${Math.abs(1 / (decimal - 1)).toFixed(2)}` : `+${Math.abs(decimal - 1).toFixed(2)}`;
  return decimal !== 0 ? converted : 0;
});
const hongKongFromDecimal = memoizeOne((decimal) => {
  return decimal !== 0 ? (decimal - 1).toFixed(2) : 0;
});
export {
  fractionalFromDecimal,
  hongKongFromDecimal,
  indonesianFromDecimal,
  malaysianFromDecimal,
  usFromDecimal
};
